import { useTranslationApp } from "../../lib/i18next";
import Chip from "@mui/material/Chip";
import { OPTIONAL } from "../../i18n/keysTranslations";
import {
  CHIP_SEARCH_COMPONENT_COLOR,
  INPUT_COLOR_BORDER,
} from "../../utils/colors";

/** Matches ChipAIGenerated small chip: height, label size and padding. */
const chipOptionalCompanionSx = {
  height: 24,
  "& .MuiChip-label": {
    fontSize: "0.8125rem",
    lineHeight: 1.43,
    px: 1,
  },
};

const ChipOptional = ({ size = "small", label, sx = {} }) => {
  const { t } = useTranslationApp();
  return (
    <Chip
      label={label ?? t(OPTIONAL)}
      size={size}
      sx={{
        backgroundColor: CHIP_SEARCH_COMPONENT_COLOR,
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        ...chipOptionalCompanionSx,
        ...sx,
      }}
    />
  );
};

export default ChipOptional;
